// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3yhJt","title":"styles_title__1sXM2","description":"styles_description__2gvb-","body":"styles_body__hOTdl","actions":"styles_actions__1oefj"};